import React, { useMemo } from "react";
import { Column, Row, useScreenSize } from "@lookiero/sty-psp-ui";
import { style as bodyStyle } from "./Body.style";
const Body = ({ children, style: customStyle, size, testID }) => {
    const style = useMemo(() => bodyStyle(), []);
    const screenSize = useScreenSize();
    const rowStyle = screenSize === "S" ? style.rowSmall : style.rowLarge;
    return (React.createElement(Row, { style: [style.row, rowStyle, customStyle?.row], testID: testID },
        React.createElement(Column, { size: size, style: [style.column, customStyle?.column] }, children)));
};
export { Body };
